export default function validateEmailDomain(domain) {
  if (/^[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(domain)) {
    return true
  } else {
    return false
  }
}
